import { render, staticRenderFns } from "./SystemEditPanel.vue?vue&type=template&id=79aa1f24&"
import script from "./SystemEditPanel.vue?vue&type=script&lang=js&"
export * from "./SystemEditPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports